/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sent an email to contact with Tenants
         * @param {string} tenantName The tenant name
         * @param {string} name The owner name
         * @param {string} email The email address
         * @param {string} phonePrefix The phone prefix
         * @param {string} phone The phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail: async (tenantName: string, name: string, email: string, phonePrefix: string, phone: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantName' is not null or undefined
            assertParamExists('sendEmail', 'tenantName', tenantName)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('sendEmail', 'name', name)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('sendEmail', 'email', email)
            // verify required parameter 'phonePrefix' is not null or undefined
            assertParamExists('sendEmail', 'phonePrefix', phonePrefix)
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('sendEmail', 'phone', phone)
            const localVarPath = `/api/email/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tenantName !== undefined) {
                localVarQueryParameter['tenantName'] = tenantName;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (phonePrefix !== undefined) {
                localVarQueryParameter['phonePrefix'] = phonePrefix;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sent an email to contact with Tenants
         * @param {string} tenantName The tenant name
         * @param {string} name The owner name
         * @param {string} email The email address
         * @param {string} phonePrefix The phone prefix
         * @param {string} phone The phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmail(tenantName: string, name: string, email: string, phonePrefix: string, phone: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmail(tenantName, name, email, phonePrefix, phone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailApiFp(configuration)
    return {
        /**
         * 
         * @summary Sent an email to contact with Tenants
         * @param {string} tenantName The tenant name
         * @param {string} name The owner name
         * @param {string} email The email address
         * @param {string} phonePrefix The phone prefix
         * @param {string} phone The phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(tenantName: string, name: string, email: string, phonePrefix: string, phone: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendEmail(tenantName, name, email, phonePrefix, phone, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI {
    /**
     * 
     * @summary Sent an email to contact with Tenants
     * @param {string} tenantName The tenant name
     * @param {string} name The owner name
     * @param {string} email The email address
     * @param {string} phonePrefix The phone prefix
     * @param {string} phone The phone number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public sendEmail(tenantName: string, name: string, email: string, phonePrefix: string, phone: string, options?: AxiosRequestConfig) {
        return EmailApiFp(this.configuration).sendEmail(tenantName, name, email, phonePrefix, phone, options).then((request) => request(this.axios, this.basePath));
    }
}
